const BASE_URL = "https://chatwoot.alfa-victor.com";
const WEBSITE_TOKEN = "Cw85bKX4PfPAip1NcLMs1L8o";
const BETA_STYLE_ID = "eh-chatwoot-beta-styles";
const BETA_BADGE_CLASS = "eh-chatwoot-beta-badge";

let loadPromise = null;
let desiredBubbleVisible = false;

function ensureBetaStyles() {
  if (document.getElementById(BETA_STYLE_ID)) {
    return;
  }

  const style = document.createElement("style");
  style.id = BETA_STYLE_ID;
  style.textContent = `
    .${BETA_BADGE_CLASS} {
      position: absolute;
      z-index: 2147483647;
      display: inline-flex;
      align-items: center;
      gap: 4px;
      padding: 2px 7px;
      border-radius: 999px;
      background: #5b2c6f;
      color: #fff;
      font: 700 10px/1.2 system-ui, -apple-system, "Segoe UI", sans-serif;
      letter-spacing: 0.06em;
      text-transform: uppercase;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
      pointer-events: none;
      user-select: none;
    }
    .${BETA_BADGE_CLASS}::before {
      content: "";
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #7dcea0;
      box-shadow: 0 0 0 2px rgba(125, 206, 160, 0.35);
    }
    #cw-bubble-holder {
      position: relative;
    }
    #cw-bubble-holder .${BETA_BADGE_CLASS} {
      top: -4px;
      right: 4px;
    }
    #cw-widget-holder {
      position: fixed;
    }
    #cw-widget-holder .${BETA_BADGE_CLASS} {
      top: 12px;
      right: 56px;
    }
    #cw-widget-holder.woot--hide .${BETA_BADGE_CLASS},
    #cw-bubble-holder.eh-chatwoot-bubble-hidden .${BETA_BADGE_CLASS} {
      display: none;
    }
  `;
  document.head.appendChild(style);
}

function ensureBetaBadge(holder, label) {
  if (!holder) {
    return null;
  }
  let badge = holder.querySelector(`.${BETA_BADGE_CLASS}`);
  if (!badge) {
    badge = document.createElement("div");
    badge.className = BETA_BADGE_CLASS;
    badge.setAttribute("aria-label", "Support chat is in beta testing");
    badge.title = "Support chat is in beta testing";
    badge.textContent = label;
    holder.appendChild(badge);
  }
  return badge;
}

function syncBetaBadges() {
  ensureBetaStyles();
  const bubbleHolder = document.getElementById("cw-bubble-holder");
  const widgetHolder = document.getElementById("cw-widget-holder");

  if (bubbleHolder) {
    bubbleHolder.classList.toggle(
      "eh-chatwoot-bubble-hidden",
      !desiredBubbleVisible,
    );
    ensureBetaBadge(bubbleHolder, "Beta");
  }
  if (widgetHolder) {
    ensureBetaBadge(widgetHolder, "Beta");
  }
}

function observeChatwootHolders() {
  const attach = () => {
    syncBetaBadges();
  };

  attach();

  if (!window.__ehChatwootBetaObserver) {
    window.__ehChatwootBetaObserver = new MutationObserver(attach);
    window.__ehChatwootBetaObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "style"],
    });
  }
}

function loadChatwoot() {
  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = new Promise((resolve) => {
    if (window.$chatwoot) {
      window.$chatwoot.toggleBubbleVisibility(
        desiredBubbleVisible ? "show" : "hide",
      );
      observeChatwootHolders();
      resolve(window.$chatwoot);
      return;
    }

    window.chatwootSettings = {
      hideMessageBubble: true,
    };

    const script = document.createElement("script");
    script.src = `${BASE_URL}/packs/js/sdk.js`;
    script.async = true;
    script.onload = () => {
      window.chatwootSDK.run({
        websiteToken: WEBSITE_TOKEN,
        baseUrl: BASE_URL,
      });
      window.addEventListener(
        "chatwoot:ready",
        () => {
          window.$chatwoot.toggleBubbleVisibility(
            desiredBubbleVisible ? "show" : "hide",
          );
          observeChatwootHolders();
          resolve(window.$chatwoot);
        },
        { once: true },
      );
    };
    document.body.appendChild(script);
  });

  return loadPromise;
}

export async function setChatwootBubbleVisible(visible) {
  desiredBubbleVisible = visible;
  await loadChatwoot();
  if (window.$chatwoot) {
    window.$chatwoot.toggleBubbleVisibility(visible ? "show" : "hide");
  }
  syncBetaBadges();
}
